import React from 'react';
import './intro.css';
import bg from '../../assets/godfreykuteesa.png';

const Intro = () => {
    return (
        <section id="intro">
            <div className="introContent">
                <span className="hello">Hello,</span>
                <span className="introText">I'm <span className="introName">Godfrey Kuteesa</span> <br />Mentor &amp; Youth Advocate</span>
                <p className="introPara">Helping boys grow in character, leadership and purpose through the Boys' Mentorship Programme.</p>
            </div>
            <img src={bg} alt="Godfrey Kuteesa" className="bg" />
        </section>
    );
}

export default Intro;

